// @flow

const isRelativeURL = (url) => {
  return url[0] === '/' || url[0] === '#';
};

const isMissingScheme = (url) => !/^[a-z0-9]+:\/\//.test(url);

// This function normalizes URLs for certain hosts (eg. dashboard.stripe.com)
// by replacing the hostnames with those for the current environment.
export const normalizeHostname = (
  rawHref: string,
  hosts: {[string]: string} = {},
) => {
  try {
    let href = rawHref;
    if (isMissingScheme(rawHref) && !isRelativeURL(rawHref)) {
      // This is to avoid broken links like 'stripe.com/pricing'
      // and 'dashboard.stripe.com'

      // Be careful in updating this logic - we need to ensure to not to accidentally
      // add in https:// for links like '#payouts' or '/docs/currences' or 'api/balances',

      // eslint-disable-next-line no-console
      console.warn(
        `href with missing scheme passed into Link component. Assuming https:// ${rawHref}`,
      );
      href = `https://${rawHref}`;
    }

    const url = new URL(href, 'https://stripe.com');
    const host = hosts[url.hostname];

    if (!host) {
      return href;
    }

    url.hostname = new URL(host).hostname;
    return url.toString();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(`Failed to parse URL in Markdoc content: ${rawHref}`);
    return rawHref;
  }
};
